import { useState, useEffect } from 'react'
import styles from './KioskLanding.module.css'
import { useNavigate } from "react-router-dom"
// ------ Services ------ //
import * as kioskService from '../../../services/kioskService'
import * as clientEventService from '../../../services/clientEventService'

const KioskLanding = ({
    user,
}) => {
    const [kioskSetting, setKioskSetting] = useState();
    const [backgroundImage, setBackgroundImage] = useState();
    const [headerImage, setHeaderImage] = useState();
    const [sponsorImage, setSponsorImage] = useState();
    const [client, setClient] = useState({})
    const [clientEventInfo, setClientEventInfo] = useState({})
    // useLocation & useNavigate --- Client state from previous page
    const navigate = useNavigate()

    // --- REST --- //
    const createRequestBody = async () => {

        let requestBody = {}

        if (user.ClientId && user.EventId) {
            requestBody =
            {
                "clientId": `${user.ClientId}`,
                "eventId": `${user.EventId}`
            }
        }
        else if (clientEventInfo && clientEventInfo.clientId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`,
            }
        }

        return await requestBody;
    }
    
    // have to fetch header and sponsor
    useEffect(() => {
        if (client && client.clientId) {
            const fetchData = async () => {
                const req = await createRequestBody();
                const setting = await kioskService.getLandingSetting(req)
                if (setting && setting.useBackgroundImage !== undefined && setting.useBackgroundImage === true && setting.backgroundBase64Image) {
                    var tempBackground = 'url(${setting.backgroundBase64Image})';
                    let backgroundImage = {
                        "base64Image": `${setting.backgroundBase64Image}`,
                        "backgroundString": `${tempBackground}`
                    };
                    setBackgroundImage(backgroundImage);
                }
                else {
                    if (setting && (setting.useBackgroundImage === undefined || setting.useBackgroundImage === false) &&
                        setting.headerBase64Image && setting.headerImageWidth) {
                        let tempwidth = setting.headerImageWidth.toString().includes('px') ? setting.headerImageWidth.toString() : setting.headerImageWidth.toString() + 'px';
                        let tempheight = setting.headerImageHeight.toString().includes('px') ? setting.headerImageHeight.toString() : setting.headerImageHeight.toString() + 'px';
                        let headerImage = {
                            "base64Image": `${setting.headerBase64Image}`,
                            "width": `${tempwidth}`,
                            "height": `${tempheight}`,
                        };
                        setHeaderImage(headerImage);
                    }
                    if (setting && (setting.useBackgroundImage === undefined || setting.useBackgroundImage === false) &&
                        setting.sponsorBase64Image && setting.sponsorImageWidth) {
                        let tempwidth = setting.sponsorImageWidth.toString().includes('px') ? setting.sponsorImageWidth.toString() : setting.sponsorImageWidth.toString() + 'px';
                        let tempheight = setting.sponsorImageHeight.toString().includes('px') ? setting.sponsorImageHeight.toString() : setting.sponsorImageHeight.toString() + 'px';
                        let sponsorImage = {
                            "base64Image": `${setting.sponsorBase64Image}`,
                            "width": `${tempwidth}`,
                            "height": `${tempheight}`,
                        };
                        setSponsorImage(sponsorImage);
                    }
                }
               
                //else if (setting && setting.sponsorBase64Image) {
                //    let sponsorImage = {
                //        "base64Image": `${setting.sponsorBase64Image}`
                //    };
                //    setSponsorImage(sponsorImage);
                //}
                setKioskSetting(setting)
            }
            fetchData()
        }
    }, [client])
    useEffect(() => {
        // store into local object
        let localclientevent = clientEventService.getClientEvent()
        if (localclientevent) {
            setClientEventInfo(localclientevent)
            setClient(localclientevent)
        }
        else {
            // use user details
            let userDetails = {}
            userDetails =
            {
                "clientId": `${user.ClientId}`,
                "eventId": `${user.EventId}`,
            }
            if (userDetails) {
                setClient(userDetails)
            }
        }
    }, [])


    return (
        <div id="kiosk_main">
            {!kioskSetting ?
                <h1 className={styles.setupFailure}>Event Kiosk Setup is not complete!</h1>
                : <></>}
            {headerImage && headerImage.base64Image && headerImage.width ?
                <div className={styles.headerHolder}>
                    <img className={styles.headerImage} src={headerImage.base64Image} style={{ width: headerImage.width, height: headerImage.height }} />
                </div> :
                <></>
            }
            {backgroundImage && backgroundImage.base64Image ?
                <div className={styles.backgroundHolder}>
                    <img className={styles.backgroundImage} style={{ background: backgroundImage.backgroundString }} />
                </div> :
                <></>
            }
            {kioskSetting ?
                <div>
                    <h2>{kioskSetting.pageTitle}</h2>
                    <br /><br />
                    {kioskSetting.firstClientEvent && kioskSetting.firstEventLabel ? 
                        <button className={styles.leftPane} id={styles.PrintButton} onClick={() => navigate(`/Kiosk/Index`, { state: kioskSetting.firstClientEvent })}>
                            {kioskSetting.firstEventLabel}
                        </button>
                        : null}
                    {kioskSetting.secondClientEvent && kioskSetting.secondEventLabel ?
                        <button className={styles.rightPane} id={styles.PrintButton} onClick={() => navigate(`/Kiosk/Index`, { state: kioskSetting.secondClientEvent })}>
                            {kioskSetting.secondEventLabel}
                        </button>
                        : null}
                    <br /><br />
                    {kioskSetting.thirdClientEvent && kioskSetting.thirdEventLabel ?
                        <button className={styles.leftPane} id={styles.PrintButton} onClick={() => navigate(`/Kiosk/Index`, { state: kioskSetting.thirdClientEvent })}>
                            {kioskSetting.thirdEventLabel}
                        </button>
                        : null}
                    {kioskSetting.fourthClientEvent && kioskSetting.fourthEventLabel ?
                        <button className={styles.rightPane} id={styles.PrintButton} onClick={() => navigate(`/Kiosk/Index`, { state: kioskSetting.fourthClientEvent })}>
                            {kioskSetting.fourthEventLabel}
                        </button>
                        : null}
                 </div>
                : <></>}

        </div>

    );
}

export default KioskLanding;